import Input from '../../../components/Input';
import * as style from './sender.module.scss';

export const EMAIL_LABEL = "Sender's Email Address";
export const NAME_LABEL = "Sender's First Name";
export const LAST_NAME_LABEL = "Sender's Last Name";

type SenderProps = {
  name: Record<string, unknown>;
  email: Record<string, unknown>;
  lastName: Record<string, unknown>;
};

const Sender = ({ name, email, lastName }: SenderProps) => (
  <div className={style.container}>
    <div className={style.names}>
      <Input
        type="text"
        id="senderName"
        label={NAME_LABEL}
        placeholder={NAME_LABEL}
        inputStatus={name}
      />
      <Input
        type="text"
        id="senderLastName"
        label={LAST_NAME_LABEL}
        placeholder={LAST_NAME_LABEL}
        inputStatus={lastName}
      />
    </div>
    <Input
      type="email"
      id="senderEmail"
      label={EMAIL_LABEL}
      placeholder={EMAIL_LABEL}
      inputStatus={email}
    />
  </div>
);

export default Sender;
